// Visual presets for scene colors and rendering
import type { PresetColors, AppParams } from './types';

export const PRESETS: Record<string, PresetColors> = {
  Void:     { accent: '#ff2400', aura: '#00e5ff', glow: '#ff00ff', bg: 0x020205, fog: 0x020205, rest: [0.035, 0.045, 0.075], exposure: 0.95, emissive: 0.88 },
  Prism:    { accent: '#ff3333', aura: '#33ffcc', glow: '#bf80ff', bg: 0x03020a, fog: 0x03020a, rest: [0.055, 0.045, 0.095], exposure: 1.08, emissive: 1.05 },
  Chrome:   { accent: '#c8d3ff', aura: '#7df9ff', glow: '#ffffff', bg: 0x040406, fog: 0x040406, rest: [0.075, 0.08, 0.095], exposure: 0.88, emissive: 0.62 },
  Aurora:   { accent: '#33ffcc', aura: '#bf80ff', glow: '#ff80df', bg: 0x02050c, fog: 0x02050c, rest: [0.025, 0.065, 0.085], exposure: 1.0, emissive: 1.0 },
  Infrared: { accent: '#ff2400', aura: '#ffb000', glow: '#ff005d', bg: 0x070202, fog: 0x070202, rest: [0.085, 0.025, 0.025], exposure: 1.02, emissive: 0.95 }
};

export function getDefaultParams(gridSize: number): AppParams {
  return {
    waveSpeed: 22,
    waveDecay: 1.4,
    waveWidth: 8,
    waveAmp: 1.6,
    heightMul: 3.4,
    spacing: 0.95,
    blendMode: 0,
    shapeMode: 'Dynamic',
    synthWave: 'triangle',
    attack: 0.05,
    release: 1.3,
    spin: 0.35,
    sustainPulseRate: 0.40,
    gestureControl: 'Off',
    visualPreset: 'Void'
  };
}

export function hexToRgb(h: string): { r: number; g: number; b: number } {
  h = h.replace('#', '');
  return {
    r: parseInt(h.substr(0, 2), 16) / 255,
    g: parseInt(h.substr(2, 2), 16) / 255,
    b: parseInt(h.substr(4, 2), 16) / 255
  };
}